<template>
  <div class="filling-goods-div">
    <div class="filling-goods-head-f">
      <div class="head-input-div-f">
        <div style="width: 20%; text-align: left">装箱单编号:</div>
        <input
          style="width: 80%"
          readonly="readonly"
          class="number"
          :value="number"
        />
      </div>
      <div class="head-input-div-f">
        <div style="width: 20%; text-align: left">行数:</div>
        <input style="width: 80%" readonly="readonly" :value="data.length" />
      </div>
      <div class="head-input-div-f">
        <div style="width: 20%; text-align: left">总数:</div>
        <input style="width: 80%" readonly="readonly" :value="allNum" />
      </div>
    </div>
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <van-button
        type="info"
        size="small"
        style="display: flex"
        :text="ray"
        @click="holdRay()"
      ></van-button>
      <div v-if="!ewmType">
        <input
          id="scanQRCode"
          @keyup.enter="add_mx()"
          ref="getIDInpot"
          v-model="add_data"
          v-on:blur="hideMessage()"
          readonly
          style="height: 20px; width: 100px"
          autocomplete="off"
        />
      </div>
      <span style="color: red" v-if="hostcs">测试服</span>
    </div>
    <div :style="style">
      <div class="goods-info-two-f" v-for="(i, index) in data" :key="index">
        <div style="width: 100%; text-align: right">
          <van-icon
            name="cross"
            @click="deleteData(index)"
            style="margin: 5px 5px 5px 0"
          />
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">货号</div>
            <div class="data-order">{{ i.goods_number || i.number }}</div>
          </div>
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">产品名称</div>
            <div class="data-order">{{ i.goods_name || i.name }}</div>
          </div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">供应商型号</div>
            <div class="data-order">{{ i.supplier_xh }}</div>
          </div>
          <div style="width: 50%; display: flex; align-items: center">
            <div class="right-twenty">明细码</div>
            <div class="data-order">{{ getnumber(i.gck_number) }}</div>
          </div>
        </div>
        <div class="sp-db-h">
          <div class="right-twenty">规格</div>
          <div class="data-order">{{ i.goods_normtype || i.size }}</div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex">
            <div class="right-twenty">卷号</div>
            <div class="data-order">{{ i.reel }}</div>
          </div>
          <div style="width: 50%; display: flex">
            <div class="right-twenty">卷号描述</div>
            <div class="data-order">{{ i.reel_detail }}</div>
          </div>
        </div>
        <div class="info-order-h">
          <div style="width: 50%; display: flex">
            <div class="right-twenty">数量</div>
            <div class="data-order">
              <input
                v-if="type === 'true'"
                v-model="i.goods_count"
                v-on:blur="countAll()"
                style="width: 2rem"
              />
              <span v-else>{{ i.goods_count }}</span>
            </div>
          </div>
          <div style="width: 50%; display: flex">
            <div class="right-twenty">计量单位</div>
            <div class="data-order">{{ i.unit }}</div>
          </div>
        </div>
      </div>
    </div>
    <filling-goods-nav-bar
      @getAdd="getAdd"
      :moreShow="more_show"
      :data="data"
      :type="type"
      :ewmType="ewmType"
      :fillingGoodsType="fillingGoodsType"
      @fillingGoods="fillingGoods"
      :revocationType="revocationType"
      :newDataId="newDataId"
      :mather_id="mather_id"
      @create_fillingGoods="create_fillingGoods"
      @refresh="handleRefresh"
      :number="number"
    ></filling-goods-nav-bar>
    <input type="hidden" v-model="mather_id" />
  </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import FillingGoodsNavBar from "../components/FillingGoodsNavBar";
export default {
  name: "fillingGoods",
  data() {
    return {
      hostcs: false,
      more_show: false,
      ray: "扫描中",
      parameterId: [],
      surplus: [],
      id: "",
      data: [],
      style: "",
      add_data: "",
      newData: {},
      add_data_all: {},
      newDataId: [],
      ewmType: false,
      allNum: 0,
      fillingGoodsType: true,
      revocationType: true,
      mather_id: "",
      getnumber: (i) => {
        if (i.indexOf("-") === -1) {
          return i;
        } else {
          return i.substr(0, i.indexOf("-"));
        }
      },
    };
  },
  computed: {
    ...mapState({
      number: (state) => state.number,
      FGid: (state) => state.FGid,
      type: (state) => state.type,
    }),
  },
  mounted() {
    this.getFGid("");
    this.getType("true");
    if (this.$route.query.ewm !== undefined) {
      this.ewmType = true;
    }
    let myData_have = {};
    if (this.$route.query.id !== undefined) {
      let myData = this.$route.query.id.split(",");
      let myall = [];
      for (let m of myData) {
        if (myData_have[m] === undefined) {
          myData_have[m] = "";
          myall.push(m);
        }
      }
      this.id = myall.join(",");
      //如果工程卡的条码是xxxxx-1,xxxxxx-2,xxxxx-3，其实都是同一商品，这时候看看是不是要去掉后缀判断，因为装箱单的数量应该是累计3的，而不是有3条明细
      let data = {};
      let id = this.id;
      id =
        id.substring(id.length - 1) === ","
          ? id.substring(0, id.length - 1)
          : id;
      for (let i of id.split(",")) {
        let i_name = i;
        if (i.indexOf("-") !== -1) {
          i_name = i.slice(0, i.indexOf("-"));
        }
        if (data[i_name] === "") {
          this.surplus.push(i_name);
        } else {
          data[i_name] = "";
          this.parameterId.push(i_name);
        }
      }
    }
    if (this.$route.query.type !== undefined) {
      this.getType(this.$route.query.type);
    }
    if (this.$route.query.NoNumber !== undefined) {
      this.getNumber("");
      this.getFGid("");
    }
    if (this.$route.query.number !== undefined) {
      this.getNumber(this.$route.query.number);
    }
    if (this.id !== "") {
      this.getIdData(this.parameterId.join(","));
    }
    if (this.$route.query.FGid !== undefined && this.$route.query.FGid !== "") {
      this.getFGIdData(this.$route.query.FGid);
    }
    this.$router.push({
      query: {
        id: this.$route.query.id || "",
        FGid: this.$route.query.FGid || "",
        number: this.$route.query.number || "",
      },
    });
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.78 + "px;overflow:scroll";
    this.focus();
    setTimeout(() => {
      this.countAll();
    }, 500);
    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }
  },
  methods: {
    ...mapMutations(["getNumber", "getFGid", "getType"]),
    create_fillingGoods(id){
      
      Object.assign(this.$data , this.$options.data());
      this.$store.commit('getType' , 'true')
      this.mather_id = id
    },
  fillingGoods(id){
    this.mather_id = id 
  },
  handleRefresh(){          
    this.$router.push("/fillingGoods?id=&FGid=&number=");
    window.location.reload(); 
  },
    getAdd() {
      //清楚数据
      this.add_data_all = {};
      this.data = [];
      this.allNum = 0;
      this.newDateId = [];
      this.$store.commit("getNumber", "");
      this.$store.commit("getType", "true");
      this.$store.commit("getFGid", "");
      this.mather_id = ''
    },
    countAll() {
      this.allNum = 0;
      for (let i of this.data) {
        this.allNum += parseFloat(i.goods_count);
      }
    },
    hideMessage() {
      this.ray = "已暂停，点击我继续扫码";
    },
    holdRay() {
      this.ray = "扫描中";
      this.focus();
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },

    async add_mx() {
      if (!navigator.onLine) {
        // 没有网络的时候
        Toast("当前网络故障");
        this.add_data = "";
        return;
      }
      if (this.add_data_all[this.add_data] !== undefined) {
        this.add_data = "";
        Toast("请勿重复扫码");
        return;
      }
      if (this.number !== "" && this.type === "false") {
        Toast("已装箱,不能再修改");
        return;
      }
      let add_data = this.add_data;
      // let add_data_have = this.newData[add_data.indexOf('-') === -1? add_data:add_data.slice(0,add_data.indexOf('-'))]
      // let add_data_have = this.newData[add_data]
      // if(add_data_have !== undefined){
      //   +this.data[add_data_have].goods_count++
      //   this.add_data_all[this.add_data] = ''
      //   this.add_data = ''
      //   return
      // }
      let datax = {
        number: add_data,
      };
      let packingx = await this.get(this.APIOBJ.packingOne, datax);
      if (packingx.data.status === 0) {
        this.$refs.getIDInpot.blur();
        Dialog.confirm({ message: packingx.data.msg,  
        showCancelButton: true, 
        showConfirmButton: false,
        className: 'vatDia',
        cancelButtonColor: '#f2f2f2',}).then(() => {}).catch(() => { this.focus(); });
        this.add_data = '';
        return;
      }
      for (let i in this.data) {
        if (
          this.data[i].gck_number ===
          (add_data.indexOf("-") === -1
            ? add_data
            : add_data.slice(0, add_data.indexOf("-")))
        ) {
          this.data[i].goods_count++;
          this.add_data_all[this.add_data] = "";
          this.add_data = "";
          this.countAll();
          return;
        }
      }
      this.newDataId.unshift(add_data);
      let data = {
        number: add_data,
      };
      document.getElementById("scanQRCode").disabled = true;
      let packing = await this.get(this.APIOBJ.packingOne, data);
      document.getElementById("scanQRCode").disabled = false;
      document.getElementById("scanQRCode").focus();
      // this.$store.state.commit('getNumber' , )
      if (packing.data.status === 0) {
        this.$refs.getIDInpot.blur();
        Dialog.confirm({ message: packing.data.msg,  
        showCancelButton: true,  // 显示取消按钮
        showConfirmButton: false,
        className: 'vatDia',
        cancelButtonColor: '#f2f2f2',}).then(() => {}).catch(() => { this.focus(); });
        this.add_data = '';
        return;
      }
      for (let i of packing.data.data) {
        i["gidNum"] = this.add_data;
      }
      this.data = this.data.reverse();
      this.data.push(packing.data.data[0]);
      this.add_data_all[this.add_data] = "";
      this.data = this.data.reverse(); //装箱倒叙（倒序）代码，暂时注释，每次扫码都会对数据倒叙让使用者的体验不好
      this.countAll();
      this.$store.commit("getisHttp", true); //可以进行装箱了
      this.add_data = "";
    },
    deleteData(index) {
      if (this.number !== "" && this.type === "false") {
        Toast("已装箱不能删除");
        return;
      }
      let name = this.data[index].name
        ? this.data[index].name
        : this.data[index].goods_name;
      Dialog.confirm({
        message: "确定要删除‘" + name + "’该明细吗？",
      }).then(() => {
        for (let i in this.newDataId) {
          let newDataId_i =
            this.newDataId[i].indexOf("-") === -1
              ? this.newDataId[i]
              : this.newDataId[i].slice(0, this.newDataId[i].indexOf("-"));
          if (this.data[index].gck_number == newDataId_i) {
            for (let i in this.add_data_all) {
              if (
                (i.indexOf("-") === -1 ? i : i.slice(0, i.indexOf("-"))) ===
                newDataId_i
              ) {
                delete this.add_data_all[i];
              }
            }
            this.newDataId.splice(i, 1);
          }
        }
        Toast("已删除 " + name);
        this.data.splice(index, 1);
        this.countAll();
        if (this.id !== "") {
          let id = this.id.replace(`${this.data[index].gck_number},`, "");
          this.$route.query["id"] = id;
          let query = { ...this.$route.query };
          this.$router.replace({ query });
        }
      });
    },

    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },
    async getIdData(id) {
      id =
        id.substring(id.length - 1) === ","
          ? id.substring(0, id.length - 1)
          : id;
      let data = {
        number: id,
      };
      let packing = await this.get(this.APIOBJ.packingOne, data);
      console.log(packing);
      this.data = packing.data.data;
      for (let i in packing.data.data) {
        this.newData[packing.data.data[i].gck_number] = i;
      }
      for (let s of this.surplus) {
        +this.data[this.newData[s]].goods_count++;
      }
    },
    async getFGIdData(FGid) {
      let data = { FGid };
      let packing = await this.get(this.APIOBJ.packingDetail, data);
      this.mather_id = packing.data.data.packing.id;
      this.data = packing.data.data.packing_detail;
      this.getFGid(this.$route.query.FGid);
      if (packing.data.data.packing.status !== "未执行") {
        this.getType("false");
      } else {
        this.getType("true");
      }
    },
  },
  components: {
    FillingGoodsNavBar,
  },
};
</script>

<style lang="less">
.head-input-div-f {
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
}
.filling-goods-head-f {
  padding: 10px 0;
}

.info-order {
  width: 100%;
  display: flex;
  background-color: white;
  margin: 5px 0;
  padding: 10px 0;
}
.goods-info-two-f {
  margin-top: 10px;
  background-color: #f2f2f2;
  padding-bottom: 10px;
}
.bottom-button {
  width: 25%;
}
.info-order-h {
  width: 100%;
  display: flex;
  padding-top: 5px;
}
.order-info-input {
  border-radius: 5px;
  border: 1px solid #444444;
  text-align: center;
  width: 4.5rem;
}
.info-order-data {
  width: 65%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-order-title {
  width: 35%;
}
.an-niu {
  border-radius: 5px;
  font-size: 12px;
}
.right-twenty {
  width: 1.6rem;
  margin: 0 15px;
  text-align: left;
}
.goods-info {
  margin-top: 10px;
  height: 300px;
  background-color: #f2f2f2;
}
.SbuttonDiv {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 -10px;
}
.sp-db-h {
  width: 100%;
  padding-top: 10px;
  display: flex;
}
.more-class {
  border-top: 0.5px solid #444444;
}
.vatDia{
  color:#f2f2f2 !important;
  background-color: #f80b0b !important;
  font-size: 18px !important;
}
.vatDia .van-dialog__cancel .van-button__text{
  font-size: 18px; /* 根据需求调整字体大小 */
}
.vatDia .van-dialog__cancel {
  background-color: #f80b0b ;
  color:#f2f2f2;
}

.vatDia .van-dialog__message{
    font-size: 18px;
}

</style>